import React, { useEffect, useContext } from 'react';
import { BasePage, StaticContext, Helmet } from '@sm/webassets';
import { Box } from '@wds/box';

import JumboHeader from './components/JumboHeader';
import ModernHeader from '../../components/ModernHeader';
import waitForUsabilla from '~app/helpers/waitForUsabilla';
import FilterNav from '../../components/FilterNav';
import UCSModule from '../../../components/UCSModule';
import { CategoriesProvider } from '../../components/CategoriesContext';
import { SearchProvider } from '../../components/SearchContext';

import getCanonicalUrlOrNoIndex from '~app/helpers/getCanonicalUrlOrNoIndex';
import Listings from './Listings';
import { AppListingProvider } from './components/AppListingContext/AppListingContext';
import LeftNavLayout from '../../components/Layouts/LeftNavLayout';
import SearchBox from './components/SearchBox';
import useStyles from './styles';
import NewAppDirectoryBanner from './components/NewAppDirectoryBanner';

const HomeV2 = () => {
  useEffect(() => {
    waitForUsabilla(() => {
      window.usabilla_live('show');
      window.usabilla_live('setForm', 'APP DIRECTORY');
    });
  }, []);

  const {
    environment: { subdomain, domain, tld },
    user,
    url,
  } = useContext(StaticContext);

  const { mobileSearchBox, tabletSearchBox, homeContainer, bodyContainer } = useStyles();

  const { noIndex, canonicalUrl } = getCanonicalUrlOrNoIndex(subdomain, domain, tld, url);

  return (
    <div data-testid="HomeV2__AppsDirectory" className={homeContainer}>
      <CategoriesProvider>
        <BasePage pageId="App Directory - Home" includeHeader={false} pageMetricsAttributes={null} legacyWeb="papi">
          <Helmet>
            <title>SurveyMonkey App Directory &amp; Integrations</title>
            <meta
              name="description"
              content="Integrate with over 100+ SurveyMonkey apps and plug-ins to get more done"
            />
            <If condition={!noIndex}>
              <link rel="canonical" href={canonicalUrl} />
            </If>
            <If condition={noIndex}>
              <meta name="robots" content="noindex, nofollow" />
            </If>
          </Helmet>
          <>
            <ModernHeader v2="true" />
            <NewAppDirectoryBanner />
            <JumboHeader />
          </>
          <If condition={user.isAuthenticated}>
            <UCSModule moduleName="top_bar" customLoader={<div />} />
          </If>
          <SearchProvider>
            <Box className={bodyContainer}>
              <Box className={mobileSearchBox}>
                <SearchBox />
              </Box>
              <LeftNavLayout nav={<FilterNav />}>
                <Box mb={5} className={tabletSearchBox}>
                  <SearchBox />
                </Box>
                <AppListingProvider>
                  <Listings />
                </AppListingProvider>
              </LeftNavLayout>
            </Box>
          </SearchProvider>
        </BasePage>
      </CategoriesProvider>
    </div>
  );
};

export default HomeV2;
